module.exports = __webpack_public_path__ + "static/media/marilyn-bio.ae9e9897.pdf";